<template>
<code 
    class="block_code"
    v-on:click="clickAnywhere"
><span ref="my_code_block"><slot></slot></span>

<v-icon
    style="position: absolute; right: 3px; bottom: 3px;"
    v-on:click="onCopy"
>
    mdi-content-copy
</v-icon>

</code>
</template>

<script>
export default {
    props: {
        click_anywhere_to_copy: {
            type: Boolean,
            default: function() { return true; }
        },
    },

    data() {
        return {
        }
    },

    methods: {
        clickAnywhere() {
            if ( this.click_anywhere_to_copy == false ) return;
            this.onCopy();
        },

        onCopy() {
            /* Get the text field */
            let code_span = this.$refs['my_code_block'];

            var range = document.createRange();
            range.selectNode(code_span);
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges();// to deselect

            this.$rc.snackbar('Code has been copied to clipboard.',1000);
        }
    },
}
</script>

<style lang="scss" scoped>


code.block_code
{
    margin-top: 5px;
    margin-bottom: 5px;
    width: 100%;

    position: relative; 
    padding-bottom: 10px;
    display: block;
    white-space: pre;
}

code.block_code:hover
{
    cursor: pointer;
}
</style>